class TrendingTabs extends HTMLElement {
  connectedCallback() {
    this._tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this._panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    this._active = 0;

    if (!this._tabs.length) return;

    this._tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this._activate(i));
    });

    const tabList = this.querySelector('[role="tablist"]');
    if (tabList) tabList.addEventListener('keydown', (e) => this._onKey(e));

    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:block:select', (e) => {
        const blockId = e.detail.blockId;
        const idx = this._tabs.findIndex(
          (t) => t.dataset.blockId === blockId
        );
        if (idx !== -1) this._activate(idx);
      });
    }
  }

  _activate(index) {
    if (index === this._active) return;

    this._setTab(this._active, false);
    this._setPanel(this._active, false);

    this._setTab(index, true);
    this._setPanel(index, true);

    this._active = index;
  }

  _setTab(i, active) {
    const tab = this._tabs[i];
    if (!tab) return;
    tab.setAttribute('aria-selected', active ? 'true' : 'false');
    tab.classList.toggle('is-active', active);
  }

  _setPanel(i, visible) {
    const panel = this._panels[i];
    if (!panel) return;

    if (visible) {
      panel.removeAttribute('hidden');
      requestAnimationFrame(() => {
        window.dispatchEvent(new Event('resize'));
      });
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  _onKey(e) {
    const total = this._tabs.length;
    let next = this._active;

    switch (e.key) {
      case 'ArrowRight':
      case 'ArrowDown':
        next = (this._active + 1) % total;
        break;
      case 'ArrowLeft':
      case 'ArrowUp':
        next = (this._active - 1 + total) % total;
        break;
      case 'Home':
        next = 0;
        break;
      case 'End':
        next = total - 1;
        break;
      default:
        return;
    }

    e.preventDefault();
    this._activate(next);
    this._tabs[next].focus();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (!customElements.get('trending-tabs')) {
    customElements.define('trending-tabs', TrendingTabs);
  }
});